import {HTTP} from "../_helpers/http";
import {config} from "@shared/_services/config";

export default class CategoryApi {

    static all() {
        return HTTP.get(config.articleApi.category)
            .then(response => response.data)
    }

    static byId(id, queryParams) {
        return HTTP.get(`${config.articleApi.category}/${id}`, {
            params: queryParams
        }).then(response => response.data)
    }

    static customerCategoryById(id, queryParams) {
        return HTTP.get(`${config.articleApi.customerCategory}/${id}`, {
            params: queryParams
        })
            .then(response => response.data)
    }

    static customerCategoryExport(id, articleList) {
        return HTTP.post(`${config.articleApi.customerCategory}/${id}/pdf`, articleList)
            .then(response => response.data)
    }

    static customerCategoryList() {
        return HTTP.get(config.articleApi.customerCategory)
            .then(response => response.data)
    }

    static getAll() {
        return HTTP.get('/private/shop-category')
            .then(response => response.data)
    }

    static categoryFilterList(id) {
        return HTTP.get(`${config.articleApi.categoryFilterList}/${id}`)
            .then(response => response.data)
    }


    static fetchUserShops() {
        return HTTP.get(config.articleApi.customerCategorySession)
            .then(response => response.data)
    }

    static updateMeta(meta) {
        return HTTP.post("/article-collection-meta", meta)
            .then(response => response.data);
    }

    static syncWithDmix(categoryId) {
        return HTTP.post(`/category/${categoryId}/sync`)
            .then(response => response.data);
    }
}